// Подтверждение вторым касанием (В13, 1.27.8): первое касание «взводит» кнопку
// (она спрашивает «точно?»), второе выполняет действие. Через ARM_MS кнопка остывает
// сама — раньше взведённые «Очистить» и «Снять с публикации» оставались такими
// навсегда и срабатывали от случайного касания много позже.
import { get, writable } from 'svelte/store';

export const ARM_MS = 4000;

export function createArm(ms = ARM_MS) {
  const armed = writable(null);
  let timer = null;

  function reset() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    armed.set(null);
  }

  // true — второе касание, выполнять; false — только взвели.
  function tap(key) {
    if (get(armed) === key) {
      reset();
      return true;
    }
    if (timer) {
      clearTimeout(timer);
    }
    armed.set(key);
    timer = setTimeout(reset, ms);
    return false;
  }

  return { armed, tap, reset };
}
